<script setup lang="ts">
import {useCachedMainNavigation} from "~/components/server/useCachedMainNavigation";
import '~/assets/css/page-transitions.css'

defineOptions({
  name: "DefaultLayout",
});

// Navigation for default theme (depth 1 is 2 level navi, depth 2 is 3 level navi, and so on)
const { data } = useAsyncData("mainNavigation", () => {
  return useCachedMainNavigation (1, "main-navigation");
});
provide("swNavigation-main-navigation", data);

const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return useCachedMainNavigation (1, "footer-navigation");
});
provide("swNavigation-footer-navigation", footerData);

const { data: topNavigationData } = useAsyncData( "mainServiceNavigation", ()=> {
  return useCachedMainNavigation (1, "service-navigation");
})
provide("swNavigation-service-navigation", topNavigationData)

const route = useRoute()
const { isLoading } = usePageLoading()
</script>
<template>
  <div>
    <LayoutHeader />
    <LayoutNotifications />
    <div class="relative">
      <!-- Loading overlay for immediate feedback -->

        <div
            v-if="isLoading"
            class="fixed translate-y-1/2 inset-0 flex justify-center z-[9999] "
        >
          <div class="opacity-30">
            <img src="data:image/webp;base64,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" class="logo-loading" alt="Zebra Logo" />
            <div class="dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>

        </div>


      <Transition name="page-fade" mode="out-in">
        <div

            :class="['page-wrapper', { 'fade-out': isLoading, 'fade-in': !isLoading }]"
        >
          <main class="mx-auto min-h-[700px]">
            <slot />
          </main>
          <LayoutFooter />
        </div>
      </Transition>

    </div>
  </div>
</template>

<style>
.logo-loading {
  width: 175px;
  animation: pulse 1.4s infinite cubic-bezier(.4,0,.6,1);
  filter: drop-shadow(0 0 8px #fff5);
  opacity: 0.7;
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(0.98);
  }
  50% {
    opacity: 1;
    transform: scale(1.03);
  }
}
/* Optional: Ladepunkt darunter */
.dots {
  display: flex;
  justify-content: center;
  margin-top: 28px;
  margin-left:10px;
  gap: 7px;
}
.dot {
  width: 13px;
  height: 13px;
  background: #000;
  border-radius: 50%;
  opacity: 0.4;
  animation: bounce 1.4s infinite;
}
.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }
@keyframes bounce {
  0%, 80%, 100% { transform: scale(1); opacity: 0.4;}
  40% { transform: scale(1.2); opacity: 1;}
}
</style>
